function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text);\n  transition: color 0.2s ease;\n  padding: 0.5rem 0;\n\n  @media (max-width: 400px) {\n    padding: 0.25rem 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 0.75rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: var(--theme-text);\n  transition: color 0.2s ease;\n  \n  ",
        "\n\n  @media (max-width: 400px) {\n    font-size: 0.9rem;\n    line-height: 1.55;\n  }\n  @media (max-width: 350px) {\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-template-rows: ",
        ";\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  max-height: 350px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.5rem;\n  height: ",
        ";\n  max-height: ",
        ";\n  min-height: ",
        ";\n  \n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  margin-bottom: 0.75rem;\n  border: 1px solid var(--theme-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  background-color: var(--theme-paper-light);\n  display: flex;\n  text-decoration: none;\n  color: inherit;\n\n  &:hover {\n    border-color: var(--theme-border-light);\n    background-color: var(--theme-paper-hover);\n  }\n\n  @media (max-width: 400px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  width: 120px;\n  flex-shrink: 0;\n  overflow: hidden;\n  background-color: var(--theme-paper-dark);\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  @media (max-width: 400px) {\n    width: 100%;\n    height: 130px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  padding: 10px 14px;\n  flex-grow: 1;\n  min-width: 0;\n\n  @media (max-width: 400px) {\n    padding: 8px 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: var(--theme-text-muted);\n  display: block;\n  margin-bottom: 2px;\n  line-height: 1.3;\n\n  @media (max-width: 350px) {\n    font-size: 0.7rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--theme-text);\n  margin-bottom: 4px;\n  line-height: 1.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: 350px) {\n    font-size: 0.85rem;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.8rem;\n  color: var(--theme-text-secondary);\n  line-height: 1.5;\n  margin-bottom: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: 350px) {\n    font-size: 0.75rem;\n    -webkit-line-clamp: 1;\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: var(--theme-text-muted);\n  display: block;\n  margin-top: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: 350px) {\n    font-size: 0.7rem;\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  margin-bottom: 0.75rem;\n  border: 1px solid var(--theme-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  padding: 0.75rem;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  background-color: var(--theme-paper-light);\n  cursor: pointer;\n\n  &:hover {\n    background-color: var(--theme-paper-hover);\n  }\n\n  @media (max-width: 400px) {\n    padding: 0.6rem;\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  line-height: 1.2;\n  min-width: 0;\n\n  @media (max-width: 350px) {\n    font-size: 0.75rem;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  font-weight: 600;\n  color: var(--theme-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 1;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.85rem;\n  line-height: 1.5;\n  color: var(--theme-text-secondary);\n  margin-bottom: 0.5rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media (max-width: 350px) {\n    font-size: 0.8rem;\n    -webkit-line-clamp: 2;\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  background-color: var(--theme-paper-dark);\n\n  img,\n  div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-primary);\n  background: none;\n  border: none;\n  padding: 0;\n  margin-bottom: 0.75rem;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  \n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        '\n  position: relative;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n  border: 1px solid var(--theme-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  padding: 0.75rem;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  background-color: var(--theme-paper-light);\n  z-index: 10;\n  pointer-events: all !important;\n  \n  /* 투표 컴포넌트 내부 요소에 대한 스타일 */\n  .poll-component {\n    position: relative;\n    z-index: 15;\n    pointer-events: all !important;\n  }\n  \n  /* 투표 버튼에 대한 스타일 */\n  .poll-component [role="button"] {\n    position: relative;\n    z-index: 20;\n    pointer-events: all !important;\n    cursor: pointer;\n  }\n'
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n  border: 1px solid var(--theme-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// import { PrefixedLink as Link } from '@edusense/shared-ui-kit';
// 콘텐츠 기본 래퍼
export var ContentBaseWrapper = styled.div(_templateObject());
// 콘텐츠 텍스트
export var ContentBaseText = styled.div(_templateObject1(), function(param) {
    var $isClipped = param.$isClipped;
    return $isClipped && "\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  ";
});
// 미디어 그리드
export var MediaGrid = styled.div(_templateObject2(), function(param) {
    var _param_count = param.count, count = _param_count === void 0 ? 1 : _param_count;
    return count === 1 ? '1fr' : count >= 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)';
}, function(param) {
    var _param_count = param.count, count = _param_count === void 0 ? 1 : _param_count;
    return count === 1 ? 'auto' : count > 2 ? 'repeat(2, 1fr)' : 'auto';
});
// 미디어 아이템
export var MediaItem = styled.div(_templateObject3(), function(param) {
    var isSingle = param.isSingle;
    return isSingle ? 'auto' : '100%';
}, function(param) {
    var isSingle = param.isSingle;
    return isSingle ? '350px' : 'none';
}, function(param) {
    var isSingle = param.isSingle;
    return isSingle ? '40px' : '120px';
}, function(param) {
    var isFirst = param.isFirst, isSingle = param.isSingle;
    return isFirst && !isSingle && "\n    grid-column: 1;\n    grid-row: 1 / span 2;\n  ";
});
// 링크 프리뷰 래퍼
export var LinkPreviewWrapper = styled.a(_templateObject4());
// 링크 프리뷰 이미지
export var LinkPreviewImage = styled.div(_templateObject5());
// 링크 프리뷰 콘텐츠 영역
export var LinkPreviewContent = styled.div(_templateObject6());
// 링크 프리뷰 사이트 이름
export var LinkPreviewSite = styled.span(_templateObject7());
// 링크 프리뷰 제목
export var LinkPreviewTitle = styled.h4(_templateObject8());
// 링크 프리뷰 설명
export var LinkPreviewDescription = styled.p(_templateObject9());
// 링크 프리뷰 URL
export var LinkPreviewUrl = styled.span(_templateObject10());
// 인용 게시물 래퍼
export var QuotedPostWrapper = styled.div(_templateObject11());
// 인용 콘텐츠 작성자 정보 영역
export var QuotedAuthorContainer = styled.div(_templateObject12());
// 인용 콘텐츠 아바타
export var QuotedAuthorAvatar = styled.div(_templateObject13());
// 인용 콘텐츠 이름/아이디/날짜 래퍼
export var QuotedAuthorInfo = styled.div(_templateObject14());
// 인용 콘텐츠 이름
export var QuotedAuthorName = styled.span(_templateObject15());
// 인용 콘텐츠 아이디/날짜
export var QuotedAuthorMeta = styled.span(_templateObject16());
// 인용 콘텐츠 텍스트
export var QuotedContentText = styled.p(_templateObject17());
// 인용 콘텐츠 미디어 썸네일
export var QuotedMediaThumbnail = styled.div(_templateObject18());
// 더보기 버튼
export var ExpandButton = styled.button(_templateObject19());
// 투표 래퍼
export var PollWrapper = styled.div(_templateObject20());
// 프로젝트 카드 래퍼
export var ProjectCardWrapper = styled.div(_templateObject21()); // 링크 스타일
 // export const StyledLink = styled(Link)`
 //   color: var(--theme-primary);
 //   text-decoration: none;
 //   transition: color 0.2s ease;
 //   &:hover {
 //     text-decoration: underline;
 //   }
 // `; 
